module.exports = __webpack_public_path__ + "img/QRcode.59b7d48b.png";